
<script lang="ts">
    import { SERVICE_URL } from "../evironment";
    import type { AppFileDto } from "../global";
    import { fileServices } from "../services";
    import { getAccessToken } from "../services/session";
    import ControlFile from "./ControlFile.svelte";
    import PreViewFile from "./PreViewFile.svelte";

    export let contextId: string;

    let filesArray: AppFileDto[] = [];

    $: contextId && reload();

    export async function reload(): Promise<void>{
        filesArray = await fileServices.findFilesByContext(contextId);
    }

    function upDateSrc(file: AppFileDto){

        let url = new URL(`/api/files/content/${file.id}` , SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL(`/files/content/${file.id}`, SERVICE_URL);
        }
        
        url.searchParams.set('access_token', getAccessToken());

        window.open(url.toString(), '_blank');
    }


</script>

{#if filesArray.length > 0}

    <div class="grid-files">
        {#each filesArray as file}
            <div class="card-file">
                <span class="linkToFile" on:click={() => upDateSrc(file)}>
                    <PreViewFile {file} />
                </span>
                <div class="card-info">
                    <ControlFile {file} on:removeFile={reload} />
                </div>
            </div>
        {/each}
    </div>

{:else}
    <div class="text-center">
        <h5>No hay archivos para mostrar</h5>
    </div>
{/if}


<style lang="scss">

    .grid-files{
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(40rem, 1fr));
        gap: 1rem;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
        border-radius: 15px;
    }

    .card-file{

        margin-bottom: 5px;
        display: flex;
        flex-direction: row;

        :global(img){
            height: 150px;
            width: 150px;
            border: 1px solid black;
            object-fit: cover;
            padding: 5px;
            border-radius: 5px;
        }
    }

    .card-info{
        width: 100%;
        margin-left: 10px;
    }

    .linkToFile{
        cursor: pointer;
    }

</style>